// Handles European decimal comma: "30,00" → 30.00, "1.234,56" → 1234.56
export default function parseCurrencyInput(value: string): number {
  const stripped = value.replace(/[^0-9.,-]+/g, '');
  if (!stripped) return 0;

  const hasComma = stripped.includes(',');
  const hasDot = stripped.includes('.');

  let normalized: string;

  if (hasComma && hasDot) {
    const lastComma = stripped.lastIndexOf(',');
    const lastDot = stripped.lastIndexOf('.');
    if (lastComma > lastDot) {
      // "1.234,56" → European: dot is thousands, comma is decimal
      normalized = stripped.replace(/\./g, '').replace(',', '.');
    } else {
      // "1,234.56" → US: comma is thousands, dot is decimal
      normalized = stripped.replace(/,/g, '');
    }
  } else if (hasComma) {
    const parts = stripped.split(',');
    if (parts.length === 2 && parts[1].length <= 2) {
      // "30,00" or "30,5" → decimal comma
      normalized = stripped.replace(',', '.');
    } else {
      // "1,234,567" → thousands separators
      normalized = stripped.replace(/,/g, '');
    }
  } else {
    normalized = stripped;
  }

  return parseFloat(normalized) || 0;
}
